module.exports = __webpack_public_path__ + "img/lagerausbildung-2bohrungen.e00e2a27.jpg";